import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from '@/messages/es.json';

i18n.use(initReactI18next).init({
  lng: 'es',
  fallbackLng: 'es',
  resources: {
    es: {
      translation: messages,
    },
  },
  interpolation: {
    escapeValue: false,
    prefix: '{',
    suffix: '}',
  },
});

export default i18n;
